/**
 * Full bleed slider script functionality.
 *
 * Probably be better to prototype this out but this is nice and succient.
 */
function cdBlockFullBleedSlider() {
	(function ($) {
		const slider = ".wp-block-cd-full-bleed-slider";
		const slide = `${slider}-slide`;
		const nav = `${slider} .nav`;
		const navDot = `${nav}__dot`;
		const activeClass = "is-active";
		const pausedClass = "is-paused";
		const dragClass = "is-dragging";

		let previousPosition = "";
		let sliderDragging = false;
		let sliderAdvanced = false;

		/**
		 * Initialize the slider
		 */
		function initSlider() {
			if (!$(slider).length) return;
			$(slider).each(function () {
				let $thisSlider = $(this);
				let firstSlide = $thisSlider.find(slide).get(0);
				$(firstSlide).addClass(activeClass);
				setInterval(function () {
					let paused = $thisSlider.hasClass(pausedClass);
					let dragging = $thisSlider.hasClass(dragClass);
					if (paused || dragging) return;
					advanceSlider($thisSlider);
				}, 5000);
			});
			pauseConditions();
			//dragNavigation(); // a lot of strange mobile cases, would rather just not enable it.
			dotNavigation();
		}

		/**
		 * Check which dot needs to be active
		 */
		function activeDot(index, $slider) {
			let $dots = $slider.find(".nav__dot");
			$dots.removeClass(activeClass);
			$($dots.get(index)).addClass(activeClass);
		}

		/**
		 * Transition slider to a given index
		 *
		 * @param {int|string} index
		 * @param {jQuery} $slider
		 */
		function gotoSlide(index, $slider) {
			activeDot(index, $slider);
			let $slides = $slider.find(slide);
			$slides.removeClass(activeClass);
			let $slide = $($slides.get(index));
			setTimeout(function () {
				$slide.addClass(activeClass);
			}, 650);
		}

		/**
		 * Move slider forward one slide
		 *
		 * @param {jQuery} $slider
		 */
		function advanceSlider($slider) {
			let $slides = $slider.find(slide);
			let numSlides = $slides.length;
			let count = 0;
			let nextSlideIndex = -1;
			$slides.each(function () {
				if (nextSlideIndex >= 0) return;
				if ($(this).hasClass(activeClass)) {
					nextSlideIndex = count + 1 < numSlides ? count + 1 : 0;
				}
				count++;
			});
			gotoSlide(nextSlideIndex, $slider);
		}

		/**
		 * Move slider backward one slide
		 *
		 * @param {jQuery} $slider
		 */
		function retreatSlider($slider) {
			let $slides = $slider.find(slide);
			let numSlides = $slides.length;
			let count = 0;
			let nextSlideIndex = -1;
			$slides.each(function () {
				if (nextSlideIndex >= 0) return;
				if ($(this).hasClass(activeClass)) {
					nextSlideIndex = count - 1 >= 0 ? count - 1 : numSlides - 1;
				}
				count++;
			});
			gotoSlide(nextSlideIndex, $slider);
		}

		/**
		 * Conditions when slider should be paused.
		 *
		 * Pause When:
		 *      Element in slider is focused
		 *      Slider is clicked
		 */
		function pauseConditions() {
			$(document).on({
				// Need this to check if click is outside slider
				click: function (event) {
					$(slider).removeClass(pausedClass);
					let $slider = $(event.target).closest(slider);
					if ($slider.length) {
						$slider.addClass(pausedClass);
					}
				},
			});
			$(slider).on({
				click: function () {
					$(this).addClass(pausedClass);
					console.log("slider click");
				},
				focusin: function () {
					$(this).addClass(pausedClass);
				},
				focusout: function () {
					$(this).removeClass(pausedClass);
				},
			});
		}

		/**
		 * When someone starts dragging
		 *
		 * @param {Obj} event
		 * @returns
		 */
		function onDragging(event) {
			if (!sliderDragging) return;
			if (sliderAdvanced) {
				previousPosition = "";
				sliderDragging = false;
				return;
			}
			let currentX = event.clientX;
			if (previousPosition === "") {
				previousPosition = currentX;
			} else {
				let positionDifference = currentX - previousPosition;
				previousPosition = currentX;
				console.log(positionDifference);
				if (Math.abs(positionDifference) < 20) return; // Only advance if quick drag
				sliderAdvanced = true; // Advance only once per drag
				if (positionDifference > 0) {
					advanceSlider($(`${slider}.${dragClass}`));
				} else {
					retreatSlider($(`${slider}.${dragClass}`));
				}
			}
		}

		/**
		 * Initialize the dragging conditions
		 *
		 * @param {Obj} event
		 * @param {jQuery} $this
		 */
		function startDragging(event, $this) {
			if ($(event.target).closest(".content").length) return;
			event.preventDefault();
			$this.addClass(pausedClass);
			$this.addClass(dragClass);
			sliderDragging = true;
		}

		/**
		 * Stop slider dragging
		 */
		function stopDragging() {
			if (!sliderDragging && !sliderAdvanced) return;
			previousPosition = "";
			sliderDragging = false;
			sliderAdvanced = false;
			$(`${slider}.${dragClass}`).removeClass(dragClass);
		}

		/**
		 * Advance or retreat slider based on mouse dragging
		 */
		function dragNavigation() {
			$(slider).on({
				touchstart: function (event) {
					startDragging(event, $(this));
				},
				mousedown: function (event) {
					startDragging(event, $(this));
				},
			});
			$(document).on({
				mousemove: function (event) {
					onDragging(event);
				},
				touchmove: function (event) {
					onDragging(event);
				},
				mouseup: function () {
					stopDragging();
				},
				touchend: function () {
					stopDragging();
				},
			});
		}

		/**
		 * Initialize navigation by dots
		 */
		function dotNavigation() {
			$(navDot).on("click", function (event) {
				event.preventDefault();
				let $slider = $(this).closest(slider);
				let index = $(this).data("index");
				gotoSlide(index, $slider);
			});
		}

		// Document on ready
		$(document).ready(initSlider);
	})(jQuery);
}
cdBlockFullBleedSlider();
